import { render, staticRenderFns } from "./LabelContractsList.vue?vue&type=template&id=1d34019c"
import script from "./LabelContractsList.vue?vue&type=script&lang=js"
export * from "./LabelContractsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports